import type { Client, UploadedFile } from "@/lib/types/client";

/**
 * Excel-Vorlagen für Adressen und Ressourcen, statisch unter public/vorlagen/.
 *
 * Sie haben die CSV-Vorlagen mit Direktimport abgelöst: ihre Spalten
 * (Kontaktdaten, Einheit, Preis, Steuersatz) haben im Wizard-Datenmodell keinen
 * Platz, und eingelesen wird im Browser nichts. Der Kunde lädt die ausgefüllte
 * Datei hoch — als .xlsx oder als CSV-Export derselben Liste —, sie landet unter
 * ihrer Kategorie in documents.uploadedFiles, und das Einrichtungsteam spielt
 * sie ein.
 */
export const EXCEL_TEMPLATES = {
  addresses: { url: "/vorlagen/onboarding-adressliste.xlsx", fileName: "Onboarding - Adressliste.xlsx", category: "Adressliste" },
  ressourcen: { url: "/vorlagen/onboarding-ressourcenliste.xlsx", fileName: "Onboarding-Ressourcen Liste.xlsx", category: "Ressourcenliste" }
} as const;

export type ExcelTemplateType = keyof typeof EXCEL_TEMPLATES;

/** Die hochgeladenen, ausgefüllten Listen zu einer Vorlage. */
export function uploadedLists(client: Client, type: ExcelTemplateType): UploadedFile[] {
  return client.data.documents.uploadedFiles.filter((file) => file.type === EXCEL_TEMPLATES[type].category);
}
